<template>
    <nav class="app-user-dropdown__menu" :class="{ 'is-refer': isReferPatient }">
        <div
            v-for="(item, i) in menuItems"
            :key="i"
            class="app-user-dropdown__menu--item"
            :class="classList(item)"
            @click="item.subItems ? null : itemClicked(item.payload)"
        >
            <div v-if="!item.hidden" class="app-user-dropdown__menu--item--wrapper">
                <common-icon v-if="item.icon" :name="item.icon" size="medium"></common-icon>
                <div class="app-user-dropdown__menu--item--button">
                    <p class="app-user-dropdown__menu--item--button__header">{{ item.name }}</p>
                    <p v-if="item.description" class="app-user-dropdown__menu--item--button__description">
                        {{ item.description }}
                    </p>
                </div>
            </div>

            <div v-if="item.subItems" class="app-user-dropdown__menu--item__submenu">
                <div class="app-user-dropdown__menu--item__submenu--items">
                    <button
                        v-for="(subItem, index) in item.subItems"
                        :key="index"
                        type="button"
                        :class="classListSubitem(subItem)"
                        @click="itemClicked(subItem.payload)"
                    >
                        {{ subItem.name }}
                    </button>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        props: {
            menuItems: { type: Array, required: true },
            isReferPatient: { type: Boolean, default: false },
        },

        data() {
            return {
                PracticeTypeEnum: PracticeTypeEnum,
            }
        },

        methods: {
            itemClicked(payload) {
                this.$emit('item-clicked', payload)
            },

            classList(item) {
                return {
                    'app-user-dropdown__menu--item__arrow': item.subItems?.length,
                    'app-user-dropdown__menu--item__disabled': item.disabled,
                }
            },

            classListSubitem(subItem) {
                return {
                    'app-user-dropdown__menu--item__disabled': subItem.disabled,
                }
            },
        },
    }
</script>
